import type { FC } from 'react';
import styled from 'styled-components';

import ErrorComponent from 'app/ui/components/atoms/error';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90vh;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(9)};
`;

type ErrorMoleculeProps = {
  details?: string;
  title?: string;
  message?: string;
};

const ErrorMolecule: FC<ErrorMoleculeProps> = ({ details, title, message }) => (
  <Wrapper>
    <ErrorComponent details={details} title={title} message={message} />
  </Wrapper>
);

export default ErrorMolecule;
